import { GridWidget } from '../types';

interface CryptoExplorerProps extends GridWidget {}

const TABLE_COLUMNS = [
  { label: 'widget.cryptoExplorer.name', fixed: true, t: 'name' },
  { label: 'widget.cryptoExplorer.symbol', t: 'symbol' },
  { label: 'widget.cryptoExplorer.lastPrice', fixed: true, t: 'lastPrice' },
  {
    label: 'widget.cryptoExplorer.pricePerformanceDaily',
    fixed: true,
    t: 'pricePerformanceDaily',
  },
  { label: 'widget.cryptoExplorer.weeklyHighest', t: 'weeklyHighest' },
  { label: 'widget.cryptoExplorer.weeklyLowest', t: 'weeklyLowest' },
  {
    label: 'widget.cryptoExplorer.pricePerformanceWeekly',
    t: 'pricePerformanceWeekly',
  },
  { label: 'widget.cryptoExplorer.volume', t: 'volume' },
  { label: 'widget.cryptoExplorer.marketCap', t: 'marketCap' },
];

const LIMIT = 50;

export { TABLE_COLUMNS, LIMIT };
export type { CryptoExplorerProps };
